import { useEffect, useState } from 'react'

import useApi from './useApi'

/**
 * Fetch completed sponsored events (Event Multiplier cards) for a business.
 *
 * Backend endpoint:
 *  GET /businesses/:id/completed_sponsored_events.json
 *
 * Expected response shape:
 *  { events: [...] }
 */
export default function useBusinessCompletedSponsoredEvents({
  businessId,
  enabled = true,
}) {
  const { getBusinessCompletedSponsoredEvents } = useApi()

  const [events, setEvents] = useState([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  useEffect(() => {
    if (!enabled || businessId == null || businessId === '') {
      setEvents([])
      setLoading(false)
      setError(null)
      return
    }

    let cancelled = false
    setLoading(true)
    setError(null)

    const run = async () => {
      try {
        const { data } = await getBusinessCompletedSponsoredEvents(businessId)
        const nextEvents = data?.events
        if (!cancelled) setEvents(Array.isArray(nextEvents) ? nextEvents : [])
      } catch (err) {
        if (!cancelled) {
          setError(err)
          setEvents([])
        }
      } finally {
        if (!cancelled) setLoading(false)
      }
    }

    run()
    return () => {
      cancelled = true
    }
  }, [enabled, businessId, getBusinessCompletedSponsoredEvents])

  return { events, loading, error }
}
